import { AGE_MAX_VALUE, AGE_MIN_VALUE } from './constants'
import { useFindLocaleText } from '../../text-localisation'

enum InputTypes {
  number = 'number',
  text = 'text',
}

export enum RangeFieldTypes {
  age = 'age',
}

export type RangeFilterInputConfig = {
  name: string
  value: string
  type: InputTypes
  placeholder: string
  label: string
  errorMessage: string
}

export const useRangeFilterInput = (): {
  createConfiguration: (
    rangeFieldType: RangeFieldTypes,
    value?: string,
  ) => RangeFilterInputConfig
  isRangeFilterValueValid: (
    rangeFieldType: RangeFieldTypes,
    value?: string,
  ) => boolean
} => {
  const localiseText = useFindLocaleText()

  const configurations = {
    age: {
      name: 'age',
      type: InputTypes.number,
      placeholder: `${localiseText('find.age_input.label')}...`,
      label: localiseText('find.age_input.label'),
      minValue: AGE_MIN_VALUE,
      maxValue: AGE_MAX_VALUE,
      errorMessage: localiseText('find.age_input.error_message', {
        min: AGE_MIN_VALUE,
        max: AGE_MAX_VALUE,
      }),
    },
  }

  const createConfiguration = (
    rangeFieldType: RangeFieldTypes,
    value?: string,
  ): RangeFilterInputConfig => {
    return { ...configurations[rangeFieldType], value: value || '' }
  }

  const isRangeFilterValueValid = (
    rangeFieldType: RangeFieldTypes,
    value?: string,
  ) => {
    const { minValue, maxValue } = configurations[rangeFieldType]
    return (
      value === undefined ||
      (Number(value) >= Number(minValue) && Number(value) <= Number(maxValue))
    )
  }

  return { createConfiguration, isRangeFilterValueValid }
}
